var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompetition(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 183.474,
    height: 173.397,
    viewBox: "0 0 183.474 173.397",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "competition",
    transform: "translate(-47.623 -96.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(47.623 106.211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M168.2,147.455a39.228,39.228,0,0,1,16.132,3.633,30.167,30.167,0,0,1,9.407,6.669c5.179,5.57,7.228,13.729,3.688,19.858-2.962,5.1-9.463,8.774-9.538,14.66-.093,6.855,8.606,11.419,16.188,12.835s16.076,1.7,21.777,6.576c4.9,4.21,6.2,10.935,4.583,16.561S224.7,238.566,220.1,242.59c-11.494,10.041-26.247,16.654-41.373,21.851A295.854,295.854,0,0,1,77.219,280.163c-8.718-.168-18.442-1.1-24.552-6.986-6.166-5.924-6.352-15.312-2.329-22.093s11.456-11.345,19.206-14.66,16.058-5.644,23.621-9.3c5.7-2.757,11.55-8.029,9.128-13.692-1.714-4.024-6.762-5.961-11.214-7.582-6.278-2.31-12.537-4.992-17.66-9.053-5.141-4.061-9.072-9.687-9.463-15.648-.373-5.57,2.4-10.9,6.483-14.884s9.407-6.8,14.847-9.2C106.764,147.548,153.223,147.269,168.2,147.455Z",
    transform: "translate(-47.623 -147.422)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M246.176,962.747H77.068A2.075,2.075,0,0,1,75,960.679V949.968a2.075,2.075,0,0,1,2.068-2.068H246.194a2.075,2.075,0,0,1,2.068,2.068v10.711A2.1,2.1,0,0,1,246.176,962.747Z",
    transform: "translate(-22.277 -692.573)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133",
    transform: "translate(68.631 96.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M317.97,928.933H186.1l3.856-3.726,3.837-3.707H312.4l2.776,3.707Z",
    transform: "translate(-181.313 -767.868)",
    fill: "#0e538c",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M838.686,250.717l.5-2.832L838.5,243.6a18.469,18.469,0,0,1,2.031-2.7c.391.391.6,4.657.6,4.657a16.014,16.014,0,0,1,1.323-1.267c.261.6-.931,2.794-.931,2.794l-1.434,3.707Z",
    transform: "translate(-712.181 -214.052)",
    fill: "#ffe3ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M638.628,497.162c-.168.41-2.142,2.962-2.328,3.614-.168.633.633,1.863.633,1.863l2.273-2.273a7.55,7.55,0,0,0,.279,1.509.386.386,0,0,0,.41.037s.112-4.042-.3-4.75C639.205,496.473,638.628,497.162,638.628,497.162Z",
    transform: "translate(-547.628 -422.328)",
    fill: "#ffe3ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M727.347,441.007l3.781,46.664H728.26s-7.824-34.742-6.837-38.542,3.111-9.929,3.111-9.929Z",
    transform: "translate(-616.844 -375.412)",
    fill: "#0a3b56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M711.742,445.337l-1.975,4.974-2.925,36.362h-3.167s-.95-38.467.8-46.571C705.93,433.415,711.742,445.337,711.742,445.337Z",
    transform: "translate(-602.264 -374.49)",
    fill: "#0b4870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M683.437,280.976c-2.7,11.14-16.989,17.138-16.989,17.138l-.6,20.286-2.608-2.645-7.023,4.471s-2.235-14.7-3.167-17.995c-3.223,4.452-5.793,19.448-5.793,19.448a18.358,18.358,0,0,0-2.161,0,72.5,72.5,0,0,1,6.091-26.564L655.849,294l5.905,3.726c1.341-.093,1.025-4.992,2.2-5.179h.019c15.331-2.422,17.1-12.444,17.1-12.444S682.226,280.473,683.437,280.976Z",
    transform: "translate(-554.809 -245.95)",
    fill: "#019cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M711,347v13.878l-8.1-12.425,4.322-1.043A37.326,37.326,0,0,0,711,347Z",
    transform: "translate(-601.841 -300.388)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M719.023,331.494l.95,2.384-1.081,3.074-3.092-2.366V330.6Z",
    transform: "translate(-612.338 -287.043)",
    fill: "#fcd2b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M431.316,566.5H403.969L391.6,632.631h52.085Z",
    transform: "translate(-348.531 -478.998)",
    fill: "#f1c400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M622.6,711.1h35.375l9.612,39.194H626.531Z",
    transform: "translate(-536.5 -596.662)",
    fill: "#f1c400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M266.557,756.5H236.286L227.4,787.237h39.157Z",
    transform: "translate(-214.919 -633.605)",
    fill: "#f1c400"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(65.423 102.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M514.283,650.207l-1.3.987-1.379-2.459,3.092-2.235h2.738v10.339h-3.148v-6.632Z",
    transform: "translate(-511.6 -646.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    transform: "translate(66.317 103.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M519.082,655.007l-1.3.987-1.378-2.459,3.092-2.235h2.738v10.339h-3.148v-6.632Z",
    transform: "translate(-516.4 -651.3)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    transform: "translate(31.202 129.993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M333.787,799.816a1.852,1.852,0,0,1,1.08.82,2.345,2.345,0,0,1,.391,1.323,3.58,3.58,0,0,1-.3,1.546,3.078,3.078,0,0,1-.8,1.062,3.165,3.165,0,0,1-1.136.6,4.575,4.575,0,0,1-1.341.186,4.405,4.405,0,0,1-1.341-.186,3.7,3.7,0,0,1-1.118-.559,3.422,3.422,0,0,1-.838-.95,4.245,4.245,0,0,1-.484-1.341l2.794-.689a1.6,1.6,0,0,0,.261.727.686.686,0,0,0,.6.279.589.589,0,0,0,.5-.224.963.963,0,0,0,.168-.578.711.711,0,0,0-.279-.633,1.326,1.326,0,0,0-.764-.186h-.652v-2.235h.745c.577,0,.876-.279.876-.838a.4.4,0,0,0-.037-.2.688.688,0,0,0-.093-.2.408.408,0,0,0-.186-.168.622.622,0,0,0-.279-.056.541.541,0,0,0-.522.3,1.738,1.738,0,0,0-.224.615l-2.72-.689a4.177,4.177,0,0,1,.559-1.3,3.663,3.663,0,0,1,.857-.913,3.57,3.57,0,0,1,1.062-.54,3.8,3.8,0,0,1,1.211-.168,4.223,4.223,0,0,1,1.155.168,3.812,3.812,0,0,1,1.08.5,2.949,2.949,0,0,1,.8.913,2.555,2.555,0,0,1,.317,1.341,2.588,2.588,0,0,1-.391,1.509,2.242,2.242,0,0,1-.913.782Z",
    transform: "translate(-327.9 -794.6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(102.512 129.974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M710.942,802.268l3.334-3.335a2.479,2.479,0,0,0,.428-.559,1.054,1.054,0,0,0,.186-.577.6.6,0,0,0-.13-.41.481.481,0,0,0-.391-.168.571.571,0,0,0-.5.3,1.6,1.6,0,0,0-.2.876l-2.962-.261a4.931,4.931,0,0,1,.391-1.6,3.206,3.206,0,0,1,.8-1.136,3.337,3.337,0,0,1,1.136-.671,4.193,4.193,0,0,1,1.378-.224,4.372,4.372,0,0,1,1.434.224,3.051,3.051,0,0,1,1.118.652,2.929,2.929,0,0,1,.727,1.043,3.759,3.759,0,0,1,.261,1.416,3.166,3.166,0,0,1-.13.95,3.48,3.48,0,0,1-.354.8,6.452,6.452,0,0,1-.484.689,4.927,4.927,0,0,1-.54.54l-1.639,1.528h3.018v2.738h-6.874Z",
    transform: "translate(-710.7 -794.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(103.629 131.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M716.942,808.268l3.334-3.334a2.482,2.482,0,0,0,.428-.559,1.054,1.054,0,0,0,.186-.577.6.6,0,0,0-.13-.41.481.481,0,0,0-.391-.168.571.571,0,0,0-.5.3,1.6,1.6,0,0,0-.2.876l-2.962-.261a4.932,4.932,0,0,1,.391-1.6,3.206,3.206,0,0,1,.8-1.136,3.338,3.338,0,0,1,1.136-.671,4.194,4.194,0,0,1,1.378-.224,4.373,4.373,0,0,1,1.434.224,3.051,3.051,0,0,1,1.118.652,2.928,2.928,0,0,1,.727,1.043,3.76,3.76,0,0,1,.261,1.416,3.166,3.166,0,0,1-.13.95,3.481,3.481,0,0,1-.354.8,6.477,6.477,0,0,1-.484.689,4.932,4.932,0,0,1-.54.54l-1.639,1.528h3.018v2.738h-6.874Z",
    transform: "translate(-716.7 -800.5)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130",
    transform: "translate(53.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M588.2,179.5v-2.776l2.5-1.528.559,2.459-1.229.745-.615,1.1Z",
    transform: "translate(-561.804 -160.591)",
    fill: "#fcd2b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M448.121,378.5a10.542,10.542,0,0,0-1.621,1.118c0,.149.354,1.807.354,1.807l.857-.5.671.074.373-.577v-1.658Z",
    transform: "translate(-446.5 -326.02)",
    fill: "#fcd2b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M463.7,548.3c-.279.969-3,3.39-3,3.39a5.317,5.317,0,0,0,3-.8c.708-.559.689-.894.689-.894v1.7h.559l.466-2.906Z",
    transform: "translate(-458.055 -464.189)",
    fill: "#073751"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M578.614,548.3c.279.969,3,3.39,3,3.39a5.317,5.317,0,0,1-3-.8c-.708-.559-.689-.894-.689-.894v1.7h-.559l-.466-2.906Z",
    transform: "translate(-552.609 -464.189)",
    fill: "#073751"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M493.935,369.507c-.466-10.972-3.223-18.647-5.086-20.379a11.18,11.18,0,0,0-6,0c-1.863,1.732-4.62,9.407-5.086,20.4-1.7,4.452-2.366,16.84-2.366,16.84h1.975s3.67-15.294,3.483-16.542c.838-2.384,2.757-8.588,4.08-13.822.559,0,1.192,0,1.826.019,1.323,5.216,3.241,11.419,4.061,13.8-.186,1.229,3.483,16.542,3.483,16.542h1.975C496.282,386.347,495.63,373.959,493.935,369.507Z",
    transform: "translate(-470.016 -301.751)",
    fill: "#0b4870"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(11.199 23.031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M530.123,230.8a5.622,5.622,0,0,0-4.08-4.21c-1.416-.335-2.906-.056-4.34-.261a6.621,6.621,0,0,1-3.875-2.068c-.987-1.08-1.677-2.5-2.906-3.26a5.292,5.292,0,0,0-4.229-.3,6.391,6.391,0,0,0-3.13,1.844,3.719,3.719,0,0,0-.782,3.5,2.491,2.491,0,0,0,2.776,1.658,17.354,17.354,0,0,1,8.848,5.309c1.267,1.416,2.347,3.074,4.005,3.949a5.391,5.391,0,0,0,5.756-.559A5.827,5.827,0,0,0,530.123,230.8Z",
    transform: "translate(-506.617 -220.412)",
    fill: "#019cae"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M479.85,195.6c.149,9.519-7.191,18.647-7.191,18.647l-1.919,10.3h-6.036a73.271,73.271,0,0,0-1.4-8.029c-5.57,4.042-8.755,14.139-8.755,14.139a4.161,4.161,0,0,1-1.453-.745c2.235-8.271,8.29-17.9,8.29-17.9l4.08-.689,1.639-.279s.671,1.174,2.422,0a6.053,6.053,0,0,0,1.174-.652h0c4.806-3.446,7.47-14.772,7.47-14.772S479.385,195.6,479.85,195.6Z",
    transform: "translate(-451.871 -177.191)",
    fill: "#0b4870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M524.653,274.9l-2.533,8.793-2.72-7.843,1.639-.279s.671,1.174,2.422,0a5.019,5.019,0,0,0,1.192-.671Z",
    transform: "translate(-505.82 -241.719)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M525.954,267.6c-.149.894-.019,1.956-.354,2.273a5.193,5.193,0,0,0,1.49.95l1.341-.82a5.931,5.931,0,0,1-.149-2.608C527.537,267.4,525.954,267.6,525.954,267.6Z",
    transform: "translate(-510.865 -235.616)",
    fill: "#fcd2b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M522.585,235.311c0,1.714-1.378,4.657-3.092,4.657s-3.092-2.943-3.092-4.657a3.092,3.092,0,1,1,6.185,0Z",
    transform: "translate(-503.379 -206.973)",
    fill: "#ffe3ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M519.654,231.086a3.228,3.228,0,0,0-1.919-2.794,4.285,4.285,0,0,0-2.515-.037c-.838.186-2.422.652-2.422.652-.429.075-1.341,1.528-1.3,2.757a3.408,3.408,0,0,0,2.235-1.155,4.278,4.278,0,0,0,1.565,1.043,9.057,9.057,0,0,0,3.6.5.737.737,0,0,0,.41-.075A.9.9,0,0,0,519.654,231.086Z",
    transform: "translate(-499.387 -203.624)",
    fill: "#019cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M530.146,286.713l-.428.913h-.54l-.578-1.1.913-.727Z",
    transform: "translate(-513.306 -250.588)",
    fill: "#f1c400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M534.86,281.4l.466.727s-1.229,1.881-1.267,1.807-.559-1.7-.559-1.7Z",
    transform: "translate(-517.293 -247.008)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M524.631,281.65s-.969,1.732-.987,1.7-1.043-1.956-1.043-1.956l.54-.689Z",
    transform: "translate(-508.424 -246.438)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M529.91,295.6l-.41,2.478.838,2.44.708-2.44-.6-2.478Z",
    transform: "translate(-514.039 -258.563)",
    fill: "#f1c400"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129",
    transform: "translate(15.275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M531.462,128.642h-.149l-.168.019c-.112.019-.224.019-.354.037l-.708.112c-.466.093-.931.186-1.4.3l.093-.13h0a9.8,9.8,0,0,0,.857,2.2,5.77,5.77,0,0,0,1.416,1.77,4.264,4.264,0,0,0,.931.559,5.033,5.033,0,0,0,1.043.261,5.937,5.937,0,0,0,2.2-.261,5.112,5.112,0,0,0,1.025-.41,1.12,1.12,0,0,0,.354-.279.352.352,0,0,0,.13-.261,1.038,1.038,0,0,0-.354-.727,5.434,5.434,0,0,0-.838-.745,18.234,18.234,0,0,0-1.993-1.285c-.354-.2-.708-.391-1.062-.577Zm.037-.242.317.093.3.093.578.2c.391.13.764.3,1.155.447a15.706,15.706,0,0,1,2.217,1.155,5.209,5.209,0,0,1,1.025.82,2.737,2.737,0,0,1,.428.577,1.515,1.515,0,0,1,.2.838,1.5,1.5,0,0,1-.354.838,2.836,2.836,0,0,1-.6.484,5.793,5.793,0,0,1-1.229.522,6.435,6.435,0,0,1-2.608.261,5.231,5.231,0,0,1-1.3-.373,4.5,4.5,0,0,1-1.118-.745,5.868,5.868,0,0,1-1.434-2.142,7.882,7.882,0,0,1-.559-2.44h0l-.019-.112.112-.019c.466-.112.931-.2,1.416-.3l.708-.112a2.283,2.283,0,0,1,.354-.037l.186-.019Z",
    transform: "translate(-528.5 -122.509)",
    fill: "#f1c400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M552.118,103.983a16.633,16.633,0,0,0-5.682,1.3,15.61,15.61,0,0,0-4.937,3.018c.727,1.714,6.3,9.221,9.445,8.513a1.249,1.249,0,0,0,.335-.13C554.018,114.956,552.789,105.716,552.118,103.983Z",
    transform: "translate(-539.078 -102.638)",
    fill: "#f1c400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M588.23,99.514l.149-.149.149-.112.279-.224a6.731,6.731,0,0,1,.6-.41c.41-.261.8-.522,1.229-.764l.093-.056.075.093h0a8.352,8.352,0,0,1,1.3,2.142,5.793,5.793,0,0,1,.466,2.533,3.891,3.891,0,0,1-.279,1.3,4.572,4.572,0,0,1-.671,1.174,6.521,6.521,0,0,1-2.049,1.621,6.211,6.211,0,0,1-1.248.484,2.475,2.475,0,0,1-.764.075,1.394,1.394,0,0,1-.838-.354,1.468,1.468,0,0,1-.428-.745,2.513,2.513,0,0,1-.093-.727,5.805,5.805,0,0,1,.168-1.3,14.671,14.671,0,0,1,.782-2.366c.168-.373.335-.745.522-1.118l.279-.54.149-.261Zm.2.149-.373,1.136c-.13.391-.242.764-.354,1.155a17.267,17.267,0,0,0-.54,2.31,5.828,5.828,0,0,0-.075,1.118,1.145,1.145,0,0,0,.242.764.492.492,0,0,0,.279.093,1.334,1.334,0,0,0,.447-.056,4.572,4.572,0,0,0,1.006-.41,5.5,5.5,0,0,0,1.77-1.341,4.2,4.2,0,0,0,.577-.913,3.47,3.47,0,0,0,.28-1.043,5.841,5.841,0,0,0-.2-2.254,9.659,9.659,0,0,0-.913-2.18h0l.168.037c-.41.242-.82.484-1.211.764a6.441,6.441,0,0,0-.577.41l-.279.224-.13.112Z",
    transform: "translate(-575.451 -97.609)",
    fill: "#f1c400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M569.1,112.2",
    transform: "translate(-561.537 -109.327)",
    fill: "#f1c400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M553.975,102.852c-1.509-.428-6.65-2.44-9.575,3.763C546.133,107.4,553.211,105.571,553.975,102.852Z",
    transform: "translate(-541.438 -101.189)",
    fill: "#f1c400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M552.7,102.231c.037-1.1,1.565-4.322,4.937-2.235C556.463,101.654,552.7,102.231,552.7,102.231Z",
    transform: "translate(-548.192 -98.836)",
    fill: "#f1c400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M560.36,96.8h0a.423.423,0,0,1,.54.261l.186.577a.422.422,0,0,1-.261.54h0a.422.422,0,0,1-.54-.261l-.186-.577A.422.422,0,0,1,560.36,96.8Z",
    transform: "translate(-554.194 -96.777)",
    fill: "#f1c400"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128",
    transform: "translate(11.487 13.406)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    width: 0.782,
    height: 8.047,
    transform: "translate(0 0.274) rotate(-20.53)",
    fill: "#f1c400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M591.513,200.361l3.39-1.267a1.419,1.419,0,0,1,1.826.82h0l-6.036,2.254h0A1.392,1.392,0,0,1,591.513,200.361Z",
    transform: "translate(-590.519 -193.364)",
    fill: "#f1c400"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M594.358,175.2l-1.658,1.639.764,1.416,1.453-.6Z",
    transform: "translate(-565.465 -160.591)",
    fill: "#f9d4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M588.747,181.575s.838-.037,1.136-.075c.13.186-.857.484-1.025.615a6.3,6.3,0,0,0-.559,1.267v-1.528Z",
    transform: "translate(-561.885 -165.717)",
    fill: "#f9d9c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M572.039,132.34l1.025-.54-.186,1.136.82.8-1.136.168-.522,1.025-.5-1.025-1.136-.168.82-.8-.186-1.136Z",
    transform: "translate(-547.32 -125.276)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(24.571 42.57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M343,589.759l4.657,24.813h1.248s1.546-11.456-1.677-13.99c1.341-6.445,1.025-9.5.3-13.04C346.893,584.319,343,589.759,343,589.759Z",
    transform: "translate(-333.555 -537.86)",
    fill: "#fcd2b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M316.885,594.214c-1.248,4.266,1.788,24.85,1.788,24.85h1.248s2.44-9.892-.373-13.524c1.025-4.825,2.254-11.121,1.956-12.984C321.225,590.712,316.885,594.214,316.885,594.214Z",
    transform: "translate(-312.06 -542.335)",
    fill: "#fcd2b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M319.776,502.026c1.9,1.714,5.2,3.931,4.434,18.312-2.533,1.9-9.556,3.13-11.009.745.075-10.525.764-17.492,1.714-19.057C315.864,500.443,319.776,502.026,319.776,502.026Z",
    transform: "translate(-309.307 -468.532)",
    fill: "#0b4870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M297.165,333.459l.112-2.832a4.4,4.4,0,0,1-.838-1.993,3.291,3.291,0,0,1,0-1.583l2.794-1.751.056,2.832a2.168,2.168,0,0,1,.894-1.248,15.6,15.6,0,0,1-1.062,3.577,12.573,12.573,0,0,0-.466,3.092Z",
    transform: "translate(-295.6 -325.3)",
    fill: "#fcd2b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M391.6,529l.8,3.6,1.136,1.7s.093-.931-.168-1.155a8.837,8.837,0,0,1,1.416,1.583,7.686,7.686,0,0,0,.279-1.937c-.112-.373-1.714-1.211-1.714-1.211l-.466-2.552L391.6,529Z",
    transform: "translate(-373.102 -491.054)",
    fill: "#fcd2b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M319.225,440.3h-2.459s-2.645,3.483-3.577,4.452a2.845,2.845,0,0,0,.745,2.645l.913,4.862h4.862s2.068-5.793,2.18-6.3a22.423,22.423,0,0,1,5.849,11.587,2.025,2.025,0,0,0,1.677-.2s-2.254-15.424-7.768-17.026Z",
    transform: "translate(-309.258 -418.877)",
    fill: "#019cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M337.673,376.76c-.3-1.6,2.235-2.459,3.428-1.639,1.192.838,7.246,5.533,1.453,11.643-1.1-.112-7.731-1.285-7.731-1.285S333.109,375.94,337.673,376.76Z",
    transform: "translate(-326.645 -365.583)",
    fill: "#0b4870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M343.444,425.21l-1.6,2.664-.242,1.565,3.428-1.025.5-3.614Z",
    transform: "translate(-332.416 -406.265)",
    fill: "#fcd2b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M339.834,385.048s-2.627,3.279-1.453,7.1c2.273.54,3.726.726,5.551-.633s1.285-3.912,1.285-3.912l-4.024-3.8Z",
    transform: "translate(-329.551 -372.902)",
    fill: "#ffe3ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M345.217,383.8A3.051,3.051,0,0,0,343,386.147l4.75,2.142s1.472-1.844,1.136-2.869C348.533,384.4,345.217,383.8,345.217,383.8Z",
    transform: "translate(-333.555 -372.902)",
    fill: "#0b4870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M372.3,396.72l.559,3.633s1.285-1.7,1.192-2.012c-.093-.335-.615-2.44-.615-2.44Z",
    transform: "translate(-357.397 -382.748)",
    fill: "#0b4870"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 1.118,
    cy: 0.652,
    rx: 1.118,
    ry: 0.652,
    transform: "translate(14.094 18.014) rotate(-45)",
    fill: "#ffe3ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M306.572,379.846c-1.36-1.36-4.769-5.682-5.03-14.046H299.81s-1.229,9.258,4.452,16.412A5.076,5.076,0,0,0,306.572,379.846Z",
    transform: "translate(-298.32 -358.256)",
    fill: "#019cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M298.913,737.2a13.891,13.891,0,0,1-6.613,3.614h5.626l.969-1.118v1.118h1.248V737.2Z",
    transform: "translate(-292.3 -660.47)",
    fill: "#0b4870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M339.113,737.2a13.891,13.891,0,0,1-6.613,3.614h5.626l.969-1.118v1.118h1.248V737.2Z",
    transform: "translate(-325.011 -660.47)",
    fill: "#0b4870"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132",
    transform: "translate(98.799 33.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M730.078,291.042c.279.745.149,3.036-.764,3.223S727.6,290.8,727.6,290.8Z",
    transform: "translate(-720.739 -287.67)",
    fill: "#0b4870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M694.277,284.8c-1.49.354-3.223,1.192-3.409,2.124a8.112,8.112,0,0,0,.242,3.67c.354.615,2.347,4.191,3.782,3.968,1.434-.261,1.08-7.489,1.08-7.489Z",
    transform: "translate(-690.769 -282.788)",
    fill: "#0b4870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M705.881,287.8c.075.317,1.267,5.551,1.788,7.768a1.239,1.239,0,0,1-.745,1.434c-1.323.522-3.707,1.136-5.4-.242-2.85-4.918-2.18-7.358-2.068-7.656S705.881,287.8,705.881,287.8Z",
    transform: "translate(-697.716 -285.229)",
    fill: "#ffe3ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M703.557,279.309c.894-.037,7.638-.149,7.209-3.2,0,0-.3-2.105-.671-2.105-.037.186-.13,1.1-.876,1.3a1.811,1.811,0,0,0-.466-1.155s-.112,1.341-2.515,1.416S701.135,276.794,703.557,279.309Z",
    transform: "translate(-700.403 -274)",
    fill: "#0b4870"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 0.801,
    cy: 1.136,
    rx: 0.801,
    ry: 1.136,
    transform: "translate(0.996 7.988) rotate(-25.86)",
    fill: "#ffe3ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M698.859,292.681a14.214,14.214,0,0,1-.708,2.5l.149.95s-.857.428-.95,0-.95-5.011-.95-5.011l1.248-.317Z",
    transform: "translate(-695.351 -287.67)",
    fill: "#0b4870"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M729.142,365.78l-.056,1.3-.782.224-1.3-1.6,1.006-1.006Z",
    transform: "translate(-621.452 -314.79)",
    fill: "#019cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M717.508,353.633l-.5,2.589s-2.943-3.428-2.906-3.614c.019-.186.317-1.509.317-1.509Z",
    transform: "translate(-610.954 -303.724)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M732.4,351.274s1.434,2.068,1.379,1.975.54-4.6.54-4.6l-.82-.447Z",
    transform: "translate(-625.846 -301.364)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M734,377.724l.186,4.713,2.124,3.279V382.25l-1.528-4.75Z",
    transform: "translate(-627.148 -325.206)",
    fill: "#019cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M706.909,699l7.414,2.254H703.5l.242-2.254Z",
    transform: "translate(-602.33 -586.816)",
    fill: "#0b4870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M760.148,699.4l7.675,2.254H757l.242-2.254Z",
    transform: "translate(-645.863 -587.141)",
    fill: "#0b4870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M301.845,945.126H160.4l4.135-3.726H298.864Z",
    transform: "translate(-160.4 -784.061)",
    fill: "#0e538c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(208.176 228.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(0 6.557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M917.752,852.8a17.2,17.2,0,0,0-8.252-11.2,68.61,68.61,0,0,0,7.954,11.848Z",
    transform: "translate(-909.5 -841.6)",
    fill: "#1a87d8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135",
    transform: "translate(3.766 0.186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M935.321,826.718A30.4,30.4,0,0,1,929.77,807.4a101.79,101.79,0,0,1,5.793,19.522Z",
    transform: "translate(-929.717 -807.4)",
    fill: "#019cae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136",
    transform: "translate(7.787 0.186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M951.747,826.9a52.323,52.323,0,0,1,.3-10.246,17.731,17.731,0,0,1,4.08-9.258,37.1,37.1,0,0,1-4.825,20.174Z",
    transform: "translate(-951.3 -807.4)",
    fill: "#1a87d8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(6.955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M948.284,826.388A27.082,27.082,0,0,1,949.29,806.4c1.788,6.483.2,13.375-1.378,19.914Z",
    transform: "translate(-946.838 -806.4)",
    fill: "#019cae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(7.954 4.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M952.945,843.045a16.822,16.822,0,0,1,9.594-13.245A35.225,35.225,0,0,1,952.2,844.423Z",
    transform: "translate(-952.2 -829.8)",
    fill: "#019cae"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M937.379,891.369l-.652,11.009a.974.974,0,0,1-.969.969h-7.638a.974.974,0,0,1-.969-.969l-.149-2.5-.5-8.513a.974.974,0,0,1,.969-.969h8.923a.947.947,0,0,1,.82.466h0A.717.717,0,0,1,937.379,891.369Z",
    transform: "translate(-923.333 -874.752)",
    fill: "#f1c400"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(3.67 16.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M939.576,893.4l-.652,11.009a.974.974,0,0,1-.969.969h-7.638a.974.974,0,0,1-.969-.969l-.149-2.5c3.558-1.024,7.228-5.421,10.208-9.016A.717.717,0,0,1,939.576,893.4Z",
    transform: "translate(-929.2 -892.9)",
    fill: "#f1c400"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(51.083 223.807)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142",
    transform: "translate(0 7.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M75.943,833.507A20.182,20.182,0,0,0,66.2,820.3a81.255,81.255,0,0,0,9.389,13.99Z",
    transform: "translate(-66.2 -820.3)",
    fill: "#1a87d8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143",
    transform: "translate(4.46 0.224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M96.746,802.7a35.7,35.7,0,0,1-6.539-22.8,121.293,121.293,0,0,1,6.837,23.043Z",
    transform: "translate(-90.141 -779.9)",
    fill: "#019cae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(9.184 0.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M116.022,803.006a62.367,62.367,0,0,1,.354-12.09A21.068,21.068,0,0,1,121.182,780a43.984,43.984,0,0,1-5.682,23.807Z",
    transform: "translate(-115.5 -780)",
    fill: "#1a87d8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145",
    transform: "translate(8.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M111.929,802.3a32.029,32.029,0,0,1,1.174-23.6c2.124,7.656.242,15.778-1.639,23.49Z",
    transform: "translate(-110.218 -778.7)",
    fill: "#019cae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(9.389 5.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M117.476,822.029A19.869,19.869,0,0,1,128.8,806.4a41.634,41.634,0,0,1-12.2,17.25Z",
    transform: "translate(-116.6 -806.4)",
    fill: "#019cae"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M99.216,879.036l-.764,13a1.141,1.141,0,0,1-1.136,1.136H88.3a1.141,1.141,0,0,1-1.136-1.136L87,889.1l-.6-10.059a1.141,1.141,0,0,1,1.136-1.136H98.061a1.135,1.135,0,0,1,.969.559h0A.862.862,0,0,1,99.216,879.036Z",
    transform: "translate(-82.637 -859.421)",
    fill: "#f1c400"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148",
    transform: "translate(4.359 19.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M101.82,881.4l-.764,13a1.141,1.141,0,0,1-1.136,1.136H90.9a1.141,1.141,0,0,1-1.136-1.136l-.168-2.943c4.21-1.211,8.532-6.389,12.053-10.655A1.064,1.064,0,0,1,101.82,881.4Z",
    transform: "translate(-89.6 -880.8)",
    fill: "#f1c400"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    transform: "translate(180.63 121.734)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_133",
    "data-name": "Rectangle 133",
    width: 1.267,
    height: 2.701,
    transform: "translate(0 0.553) rotate(-25.86)",
    fill: "#019cae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151",
    transform: "translate(108.598 129.32)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 3.13,
    height: 1.472,
    transform: "translate(0 2.912) rotate(-68.531)",
    fill: "#019cae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152",
    transform: "translate(217.688 167.554)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    width: 1.695,
    height: 3.633,
    transform: "translate(0 0.739) rotate(-25.86)",
    fill: "#019cae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153",
    transform: "translate(74.178 174.975)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 4.21,
    height: 1.975,
    transform: "translate(0 3.918) rotate(-68.531)",
    fill: "#019cae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(192.759 186.872)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_137",
    "data-name": "Rectangle 137",
    width: 2.291,
    height: 4.881,
    transform: "translate(0 0.999) rotate(-25.86)",
    fill: "#019cae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    transform: "translate(147.463 144.479)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    width: 5.663,
    height: 2.664,
    transform: "translate(0 5.27) rotate(-68.531)",
    fill: "#019cae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(202.545 121.561)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_139",
    "data-name": "Rectangle 139",
    width: 3.092,
    height: 6.576,
    transform: "translate(0 1.349) rotate(-25.86)",
    fill: "#019cae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157",
    transform: "translate(60.056 156.549)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140",
    "data-name": "Rectangle 140",
    width: 7.638,
    height: 3.577,
    transform: "translate(0 7.108) rotate(-68.531)",
    fill: "#019cae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(92.08 109.211)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    "data-name": "Rectangle 141",
    width: 4.154,
    height: 8.848,
    transform: "translate(0 1.812) rotate(-25.86)",
    fill: "#019cae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159",
    transform: "translate(116.733 159.735)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142",
    "data-name": "Rectangle 142",
    width: 1.863,
    height: 0.876,
    transform: "matrix(0.5, -0.866, 0.866, 0.5, 0, 1.613)",
    fill: "#f1c400"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(196.228 163.313)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143",
    "data-name": "Rectangle 143",
    width: 1.025,
    height: 2.161,
    transform: "translate(0 0.579) rotate(-34.389)",
    fill: "#f1c400"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    transform: "translate(218.036 181.648)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    width: 2.515,
    height: 1.174,
    transform: "matrix(0.5, -0.866, 0.866, 0.5, 0, 2.178)",
    fill: "#f1c400"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(218.926 133.078)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 1.36,
    height: 2.925,
    transform: "translate(0 0.768) rotate(-34.389)",
    fill: "#f1c400"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    transform: "translate(81.432 187.438)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146",
    "data-name": "Rectangle 146",
    width: 1.844,
    height: 3.931,
    transform: "translate(0 1.042) rotate(-34.389)",
    fill: "#f1c400"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(75.867 135.363)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147",
    "data-name": "Rectangle 147",
    width: 6.147,
    height: 2.887,
    transform: "matrix(0.5, -0.866, 0.866, 0.5, 0, 5.324)",
    fill: "#f1c400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetition);
export default __webpack_public_path__ + "static/media/competition.0a62b731c833385f67065646dc516152.svg";
export { ForwardRef as ReactComponent };